'use client';

import { Badge } from '@/components/ui/badge';
import type { ConnectionStatus as ConnectionStatusType } from '@/lib/integrations/types';
import { getStatusLabel } from '@/lib/integrations/utils';
import { cn } from '@/lib/utils';

interface ConnectionStatusProps {
  status: ConnectionStatusType;
  className?: string;
}

const statusVariants: Record<ConnectionStatusType, 'default' | 'secondary' | 'destructive' | 'outline'> = {
  active: 'default',
  expired: 'secondary',
  revoked: 'destructive',
};

export function ConnectionStatus({ status, className }: ConnectionStatusProps) {
  return (
    <Badge variant={statusVariants[status]} className={cn(className)}>
      {getStatusLabel(status)}
    </Badge>
  );
}
